import React from 'react'
import moment from 'moment'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_NAME_AND_DATE } from '../../../../../graphql/jobDay/jobDay.queries'

// mui
import { Grid, Container, Typography } from '@mui/material'

export default function JobDayNameAndDate({ jobDayId }) {

    let jobDay = { job: {}}

    const { data } = useQuery(GET_JOB_DAY_BY_ID_WITH_NAME_AND_DATE, {
        variables: { id: jobDayId }
    })

    if(data && data.jobDay) {
        jobDay = {...data.jobDay, date: moment(data.jobDay.date).isValid() ? moment(data.jobDay.date).format("MM/DD/YYYY") : null}
    }

    return (<Container maxWidth disableGutters sx={{ marginBottom: 4}}>
        <Grid container spacing={2} alignItems='center'>
            <Grid item xs={6}><Typography variant="h2">{jobDay.date}</Typography></Grid>
            <Grid item xs={6} textAlign='right'><Typography variant="h4">{jobDay.job.name}</Typography></Grid>
        </Grid>
    </Container>
    )
}